var $this;
var $input;
var val;
var $parent;

$(document).ready(function () {
  $('.add-comment').on('click', function () {
    $this = $(this);
    $this.parent().find('textarea').css('display', 'block');
    $this.css('display', 'none');
  });

  function showComment($parent) {
    $parent.find('.comment').css('display', 'block');
    $parent.find('.add-comment').css('display', 'none');
  }

  function hideComment($parent) {
    $parent.find('.comment').css('display', 'none');
    $parent.find('.add-comment').css('display', 'block');
  }

  $('.clear-file').on('click', function (e) {
    e.preventDefault();
    $input = $(this).parents('.question__answers').find('input');
    $input.val('');
  });

  $('.occupants .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.occupants');

    if (['no', 'n/a'].includes(val)) {
      showComment($parent);
      $parent.find('.noti-text').css('display', 'none');
    } else {
      hideComment($parent);
      $parent.find('.noti-text').css('display', 'block');
    }
  });

  $('.other-occupants .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.other-occupants');

    if (['yes'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.term-of-tenancy .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.term-of-tenancy');

    if (['no', 'n/a'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.paid-on-time .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.paid-on-time');

    if (['3', '2', '1', '0'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.proprety-looked-after .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.proprety-looked-after');

    if (['3', '2', '1', '0'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.maintenance-requests-reasonable .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.maintenance-requests-reasonable');

    if (['no', 'n/a'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.have-pets .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.have-pets');

    if (['yes'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.breach-notices-sent .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.breach-notices-sent');

    if (['yes'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.how-leave-the-proprety .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.how-leave-the-proprety');

    if (['3', '2', '1', '0'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });

  $('.rent-again .radio-button').on('change', function () {
    $this = $(this);
    val = $this.val();
    $parent = $this.parents('.rent-again');

    if (['3', '2', '1', '0'].includes(val)) {
      showComment($parent);
    } else {
      hideComment($parent);
    }
  });
});
